import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-space-types-list',
  templateUrl: './space-types-list.component.html',
  styleUrls: ['./space-types-list.component.css']
})
export class SpaceTypesListComponent implements OnInit {
  spacetypes: any;
  levelOfServices:any;
  search: any;
  filteredSpacetypes: any[] = [];
  prelevelOfServices:any = {};
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  status = true
  numberOfRecords = NUMBER_OF_RECORDS
  userPermission=UserPermission
  spaceTypeModalObj:any;

  constructor(
    private SpaceTypeService: SpaceTypeService,
    private levelOfService: LosService,
    public permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.getLevelOfService();
    this.getSpaceTypes(this.currentPage);
  }

  getSpaceTypes(page:number) {
    const queryParams = {
      limit: 50,
      page,
      isActive: this.status
    }
    this.SpaceTypeService.get(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spacetypes = data.results;
        this.spacetypes = data.results.sort((a: any, b: any) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        this.filteredSpacetypes = [...this.spacetypes];
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    })
  }

  getLevelOfService() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.levelOfService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.levelOfServices = data.results;
          this.prelevelOfServices = this.levelOfServices.reduce((obj:any, item:any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getSpaceTypes(page);
  }

  onSelectStatus(event: any): void {
   this.status = event.target.value === 'true';
    this.getSpaceTypes(this.currentPage = 1);
  }


  openSpaceTypeModal(spaceType: any) {
    this.spaceTypeModalObj = spaceType;
  }

  onSaveSpaceType(evt: any) {
    if (evt) {
      const idx = this.filteredSpacetypes.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.filteredSpacetypes[idx] = evt;
      } else {
        this.filteredSpacetypes.splice(idx, 1);
      }
    }
    this.spaceTypeModalObj = null;
  }

  onCloseSpaceTypeModal() {
    this.spaceTypeModalObj = null;
  }

}
